import React from 'react'
import SearchSummary from '../../../SearchSummary/SearchSummary'

const SlrSummarySection = ({ weightSummary }) => {
	if (!weightSummary) return null

	return (
		<div className='new-booking-container'>
			<div className='search-summary-row'>
				<SearchSummary
					totalPieces={weightSummary.totalPieces}
					weightUnit={weightSummary.weightUnit}
					dimensionUnit={weightSummary.dimensionUnit}
					totalWeightInKg={weightSummary.totalWeightInKg}
					totalVolumeInMtrs={weightSummary.totalVolumeInMtrs}
					chargeableWeight={weightSummary.chargeableWeight}
					looseDetails={weightSummary.looseDetails}
					shippingType={weightSummary.shippingType}
					totalWeight={weightSummary.totalWeight}
					looseItemsGrossWeight={weightSummary.totalWeightInKg}
					calculatedTotalWeight={weightSummary.totalWeight}
					actualGrossWeight={weightSummary.totalWeightInKg}
					actualTotalIneItemWeight={weightSummary.totalWeightInKg}
					actualVolume={weightSummary.totalVolumeInMtrs}
					setGrossWeightInSelectedUnit={() => {}}
					setGrossWeightInConvertedUnit={() => {}}
					setDensityInSelectedUnit={() => {}}
					setdensityInConvertedUnit={() => {}}
					chargeableWeightInSelectedUnit={weightSummary.chargeableWeight}
					cageList={[]}
					shippingItem={null}
					AviEnabled={false}
					cages={[]}
					isSlrBooking={true}
				/>
			</div>
		</div>
	)
}

export default SlrSummarySection
